import { Chart } from "primereact/chart";

import styles from "./home-chart.module.scss";
import type { HomeChartProps, HomeChartViewModel } from "./types-home-chart";

/**
 * Curva de área dos cartões Capex e Financeiro, construída sobre o componente
 * `Chart` do PrimeReact — nenhuma outra biblioteca de gráficos é usada no
 * projeto (AC5).
 *
 * Os pontos vêm sempre por parâmetro, da camada de consulta da Home, e nunca
 * embutidos aqui (AC6). O canvas é escondido dos leitores de tela e os mesmos
 * valores são publicados em uma tabela equivalente, o que mantém os indicadores
 * legíveis quando o gráfico não pode ser interpretado.
 */
export function HomeChartView({
  data,
  options,
  plugins,
  rows,
  dadosTestId,
  ariaLabel,
  labelHeader,
  valueHeader,
  className,
  testId,
}: HomeChartViewModel &
  Pick<HomeChartProps, "ariaLabel" | "labelHeader" | "valueHeader" | "className" | "testId">) {
  return (
    <figure className={[styles.figure, className].filter(Boolean).join(" ")} data-testid={testId}>
      <div className={styles.canvas} aria-hidden>
        <Chart type="line" data={data} options={options} plugins={plugins} />
      </div>

      <table className={styles.srOnly} data-testid={dadosTestId}>
        <caption>{ariaLabel}</caption>
        <thead>
          <tr>
            <th scope="col">{labelHeader}</th>
            <th scope="col">{valueHeader}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.label}>
              <th scope="row">{row.label}</th>
              <td>{row.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </figure>
  );
}
